<footer class="footer-responsive primary-bgpurple">
    <div class="container">
        <div class="row g-md-5 g-lg-5">
            <div
                class="footer-logo col-lg-3 col-md-6 d-flex align-items-lg-end align-items-md-center justify-content-lg-start justify-content-center my-3 mb-lg-0">
                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/new-theme/ghrscf-white.png"
                    alt="GHRSCF" class="img-fluid w-100">
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="accordion-item">
                    <h6 class="accordion-header" id="h1">
                        <a class="accordion-button" data-bs-toggle="collapse" data-bs-target="#c1" aria-expanded="true">
                            IMPORTANT LINKS
                        </a>
                    </h6>
                    <div id="c1" class="accordion-collapse collapse show" aria-labelledby="h1"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <ul>
                                <li><a routerLink="/cultural-events">Cultural Events</a></li>
                                <li><a routerLink="/sport-events">Sports Events</a></li>
                                <li><a routerLink="/club">Club</a></li>
                                <li><a routerLink="/support-encouragement">Support & Encouragement</a></li>
                                <li> <a routerLink="/Photogallery">Photogallery</a></li>
                                <li> <a routerLink="/mendatory-disclosure">Mendatory Disclosure</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2  col-md-6">
                <div class="accordion-item">
                    <h6 class="accordion-header" id="h2">
                        <a class="accordion-button" data-bs-toggle="collapse" data-bs-target="#c2" aria-expanded="true">
                            PORTALS
                        </a>
                    </h6>
                    <div id="c2" class="accordion-collapse collapse show" aria-labelledby="h2"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <ul>
                                <li><a href="https://alumni.raisoni.net/" target="_blank">Alumni Portal</a></li>
                                <!-- <li><a href="https://raisoni.net/placement">RGI Placement</a></li> -->
                                <li><a href="https://www.rashtriyachhatrasansad.in/" target="_blank">NSP</a></li>
                                <li><a href="http://nationalagricultureconclave.com/" target="_blank">NAC</a></li>
                                <li><a href="https://sgrkf.com/" target="_blank">SGRKF</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-lg-3  col-md-6">
                <div class="accordion-item">
                    <h6 class="accordion-header" id="h4">
                        <a class="accordion-button" data-bs-toggle="collapse" data-bs-target="#c4" aria-expanded="true">
                            contacts
                        </a>
                    </h6>
                    <div id="c4" class="accordion-collapse collapse show" aria-labelledby="h4"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <ul class="contact">
                                <li><a href="https://maps.app.goo.gl/K7tmYAPWHcttGBdX6" target="_blank"> <i
                                            class="fa fa-map-marker"></i> 345,
                                        Kingsway Shradha House, Nagpur, Nagpur,
                                        Maharashtra, India,
                                        440001</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-lg-end justify-content-center py-lg-0 py-3">
            <div class="col-lg-3 me-lg-5 pe-lg-5">
                <div class="social-links">
                    <a href="https://www.facebook.com/raisoniworld" target="_blank"><i class="fa  fa-facebook"></i>
                    </a>
                    <a href="https://twitter.com/raisoniworld" target="_blank"><i class="fa fa-x-twitter "></i>
                    </a>
                    <a href="https://www.linkedin.com/school/raisoniworld" target="_blank"><i
                            class="fa fa-linkedin"></i> </a>
                    <a href="http://youtube.com/raisoniworld" target="_blank"><i class="fa fa-youtube"></i>
                    </a>
                    <a href="https://instagram.com/raisoniworld" target="_blank"><i class="fa fa-instagram"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="row mt-lg-2 justify-content-center flex-row-reverse g-3 g-lg-0 pt-3 pt-0">

            <!-- <div class="col-lg-5">
                <div class="text-lg-end text-center privacy">
                    <a href="https://ghru.edu.in/document/privacy_policy.html" target="_blank">Privacy Policy</a> | <a
                        href="https://ghru.edu.in/document/terms_and_conditions.html" target="_blank"> Terms &amp;
                        Conditions</a> | <a href="https://ghru.edu.in/document/refund_and_cancellation.html"
                        target="_blank">Refund &amp; Cancellation </a>
                </div>
            </div> -->
            <div class="col-lg-3 ps-lg-4 offset-lg-1">
                <div class="footer-right">
                    <p>Website Visitors:
                        <img src="https://hitwebcounter.com/counter/counter.php?page=20127972&style=0006&nbdigits=7&type=page&initCount=123793"
                            title="Hit Web Stats" alt="Hit Web Stats" border="0">
                    </p>
                </div>
            </div>
            <div class="col-lg-6 me-lg-5 pe-lg-5">
                <p class="mb-0">&copy; {{ currentyear}} All Rights Reserved. Design & Developed by <a
                        href="https://globaledu.net.in/" target="_blank">Global
                        Education Limited.</a>
                </p>
            </div>

        </div>

    </div>
</footer>
